module.exports = __webpack_public_path__ + "img/3_43.f0de40c2.png";